import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  { n: "01", title: "CONSULTATION", note: "A qualified professional assesses your lips and confirms suitability.", testid: "journey-step-1" },
  { n: "02", title: "YOUR BACIO SESSION", note: "Your Skinfill Bacio lip booster session, performed in clinic.", testid: "journey-step-2" },
  { n: "03", title: "BOOST YOUR LIPS", note: "Lips look and feel hydrated, refreshed and beautifully conditioned.", testid: "journey-step-3" },
  { n: "04", title: "MAINTAIN", note: "Your practitioner advises on maintaining your results over time.", testid: "journey-step-4" },
];

const Journey = () => (
  <section id="journey" data-testid="journey-section" className="bg-[#F4EBE6] py-24 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>The Bacio journey</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-serif font-light text-[#1C1417] text-4xl sm:text-6xl tracking-tight mt-5 text-balance leading-[1.04]">
          Four steps to <span className="italic text-[#A31D4F]">beautifully boosted lips.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={s.testid}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.12, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="relative border-t border-[#1C1417]/15 pt-6"
          >
            <p className="font-serif italic font-light text-5xl sm:text-6xl text-[#D84A75]/50">{s.n}</p>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#1C1417] mt-5">{s.title}</p>
            <p className="text-sm text-[#6E6266] font-light leading-relaxed mt-3">{s.note}</p>
          </motion.div>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-16 rounded-3xl bg-white/70 border border-[#EADECE] p-6 sm:p-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#A31D4F]">Professional guidance</p>
          <p className="text-sm text-[#6E6266] font-light leading-relaxed mt-3 max-w-3xl">
            Recommended course: minimum 3 sessions approximately 2 weeks apart, according to professional assessment
            and manufacturer guidelines. Typical product quantity: approximately 0.8 mL per session, according to
            professional assessment and manufacturer guidelines. This information is intended for aesthetic
            professionals and does not constitute consumer advice.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Journey;
